import axiosInstance from "utils/axios-request";
import {baseUrl, gatewayUrl} from "config";
import {IDocDetails, IDocument} from "StateInterface";
import {setCurrentDocTypeForEventTracking} from "analytics/branch";
import {DocTypes} from "userform/utils";

export const updateEventLog = (eventLog: any) =>
  axiosInstance.request({
    baseURL: gatewayUrl,
    url: `events/log-event`,
    method: "post",
    data: eventLog,
  });

export const uploadDocument = async (docType: DocTypes, docBody: IDocDetails) => {
    setCurrentDocTypeForEventTracking(docType);
    const res = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: "paandu/docs",
        method: "POST",
        data: {
            ...docBody,
        },
    });
    return res.data;
};

export const getAvailableDocs = async (userId: number, docTypes: string): Promise<IDocument[]> => {
    const response = await axiosInstance.request({
        baseURL: baseUrl,
        url: `document/info/${userId}`,
        method: "get",
        params: {
            docTypes,
        },
    });
    return response.data;
};
